module.exports = __webpack_public_path__ + "static/media/41.5c9cb8fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/41.jpg
// module id = 229
// module chunks = 0